import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useRef, useState} from "react";
import {archiveVendor, getCompanyVendors, saveVendor} from "../common/api/WebApi";
import {Card} from "@mui/material";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import Meta from "../common/Meta";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Footer from "../Footer";
import MDButton from "../../components/MDButton";
import {useNavigate} from "react-router-dom";
import ManageVendorModal from "../vendor/ManageVendorModal";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import NotificationItem from "../Items/NotificationItem";
import Confirm from "../common/Confirm";

export default function Vendors(props) {
  const navigate = useNavigate();

  const [context, setContext] = useContext(AppContext);

  const [saving, setSaving] = useState(false);
  const [manageEmployee, setManageEmployee] = useState(false);
  const [employee, setEmployee] = useState();
  const [vendors, setVendors] = useState([]);


  useEffect(() => {

    getVendorsFn().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setVendors(result);
      }
    });
  }, []);

  const getVendorsFn = async () => {
    return await getCompanyVendors();
  }

  const handleCloseEmployee = () => {
    setEmployee(null);
    setManageEmployee(false);
  };

  const handleSaveVendor = async (employee) => {
    setSaving(true);

    let result = await saveVendor(employee);
    setSaving(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setManageEmployee(false);
      getVendorsFn().then(result => {
        if (result.error) {
          setContext({...context, error: {message: result.message}});
        } else {
          setVendors(result);
        }
      });
    }
  };
  const [confirmation, setConfirmation] = useState(null);
  const [confirmDeleteVendor, setConfirmDeleteVendor] = useState(false);

  const handleConfirmVendor = async (vendor) => {
    setSaving(true);
    setConfirmDeleteVendor(false);
    let result = await archiveVendor(vendor);
    setSaving(false);
    setConfirmation(null);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      getVendorsFn();
    }
  }

  const archiveVendorFn = (vendor) => {
    setEmployee(vendor);
    let confirmation = {
      title: 'Charge Delete Vendor?',
      message: 'Confirm delete Vendor',
      entity: vendor
    }
    setConfirmation(confirmation);
    setConfirmDeleteVendor(true);
  };

  const startManageEmployeeFn = (e) => {
    if (!e.guid) {
      e.newEmployee = true;
    }
    setEmployee(e);
    setManageEmployee(true);
  };

  const myRefs = useRef([]);
  const [renderIndex, setRenderIndex] = useState(1);

  const refHandler = (index) => {
    myRefs.current[index].visible = !!!myRefs.current[index].visible;
    setRenderIndex(renderIndex + 1);
  };

  const VendorActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'vendor-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
           <MDButton
             variant="outlined"
             color="secondary"
             size="small"
             circular
             iconOnly
           >
            <Icon>more_horiz</Icon>
          </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                startManageEmployeeFn(item)
              }} icon={<Icon>person</Icon>} title="Manage"/>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                archiveVendorFn(item)
              }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  return (
    <DashboardLayout>

      <Meta pageTitle={'Vendors'}/>

      <ContextSearchNavbar title={'Vendors'}/>
      <MDBox py={3}>
        <Card>
          <MDBox p={3}>
            <h5 className={'mb-3'}>
              &nbsp;
              <MDButton
                onClick={(e) => {
                  setManageEmployee(true);
                  startManageEmployeeFn({});
                }}
                color="secondary"
                size="small"
                className={'pull-right'}>
                Add Vendor</MDButton>
            </h5>
            {vendors?.length > 0 && <>
              <table className="table table-striped mt-2">
                <thead>
                <tr>
                  <th scope="col">First Name</th>
                  <th scope="col">Last Name</th>
                  <th scope="col">Company</th>
                  <th scope="col">Website</th>
                  <th scope="col">Email</th>
                  <th scope="col">Phone</th>
                  <th scope="col" className={'text-right'}>Actions</th>
                </tr>
                </thead>
                <tbody>

                {vendors?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{item.firstName}</td>
                        <td>{item.lastName}</td>
                        <td>{item.companyName}</td>
                        <td>{item.website}</td>
                        <td>{item.email}</td>
                        <td>{item.phone}</td>
                        <td>
                          {/*<MDButton*/}
                          {/*  onClick={(e) => {*/}
                          {/*    setManageEmployee(true);*/}
                          {/*    startManageEmployeeFn(item);*/}
                          {/*  }}*/}
                          {/*  color="secondary"*/}
                          {/*  size="small"*/}
                          {/*  className={'pull-right'}>*/}
                          {/*  Manage</MDButton>*/}

                          <span className={'pull-right'}>
                            <VendorActions item={item}/>
                          </span>

                        </td>
                      </tr>
                    )
                  }
                )}
                </tbody>
              </table>
            </>}
          </MDBox>
        </Card>
      </MDBox>
      {
        <>
          {
            confirmation && <Confirm confirmation={confirmation}
                                     show={confirmDeleteVendor}
                                     saving={saving}
                                     handleConfirm={handleConfirmVendor}
                                     handleSave={()=>{
                                       setConfirmDeleteVendor(false);
                                     }}/>
          }
          {employee && <ManageVendorModal
            vendor={employee}
            show={manageEmployee}
            saving={saving}
            handleSave={handleSaveVendor}
            handleClose={handleCloseEmployee}/>
          }

        </>
      }

      <Footer mt={5}/>

    </DashboardLayout>
  );
}